var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C15.866 2 19 5.13401 19 9V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V16.2321C5 14.9073 5.869 13.7393 7.13796 13.3586L13.5747 11.4276C14.4207 11.1738 15 10.3952 15 9.51194V9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 9.55229 8.55229 10 8 10H6C5.44772 10 5 9.55229 5 9C5 5.13401 8.13401 2 12 2ZM9 16.7549C9 17.7908 10.2058 18.8864 11.0885 19.5496C11.4881 19.8499 11.6879 20 12 20C12.3121 20 12.5119 19.8499 12.9115 19.5496C13.7942 18.8864 15 17.7908 15 16.7549C15 15.0243 13.35 14.3782 12 15.715C10.65 14.3782 9 15.0243 9 16.7549Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorHanger);
export default __webpack_public_path__ + "static/media/door-hanger.e6769622931c3c257364588452d3942d.svg";
export { ForwardRef as ReactComponent };